import {setContext} from 'apollo-link-context';

export default setContext( req => {
    if ( window.__IS_TEST_RUNNER__ ) {
        return true;
    }

    let latency = 0;

    switch ( req.operationName ) {
        case 'GetCart':
        case 'AddLineItems':
        case 'UpdateLineItems':
        case 'DeleteLineItems':
            latency = 1500;
            break;

        case 'GetCustomerAddresses':
        case 'GetCustomerEquipment':
        case 'GetRmasByAccountNumber':
        case 'GetSmsUpsLabel':
            latency = 500;
            break;

        default:
            latency = 500;
    }

    console.warn( `[Simulate latency] ${req.operationName}`, latency );
    return new Promise( resolve => setTimeout( resolve, latency ) );
} );

